import { render, staticRenderFns } from "./AssignmentSelect.vue?vue&type=template&id=3fd5c0bf&"
import script from "./AssignmentSelect.vue?vue&type=script&lang=js&"
export * from "./AssignmentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports